import lcMosaic from '../../assets/lc-mosaic.svg'

const HeroSection = () => {
	return (
		<section className="px-6 pt-12 pb-0 border-b-4 border-ink relative">
			<div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-[1.6fr_1fr] gap-12 items-start">
				<div className="min-w-0 text-center md:text-left">
					<span className="inline-block bg-hot text-paper font-mono text-[12px] uppercase px-2 py-0.5 mb-4 before:content-['·'] before:mr-1 motion-safe:animate-rise">
						Front Page · Late Autumn
					</span>

					<h1 className="font-display font-extrabold uppercase text-[clamp(40px,11vw,84px)] md:text-[clamp(56px,7vw,110px)] leading-[.86] tracking-[-0.04em] text-ink motion-safe:animate-rise motion-safe:[animation-delay:60ms]">
						Engineering Leader,{' '}
						<span className="font-serif italic font-normal normal-case inline-block leading-[0.95]">Building</span>{' '}
						the{' '}
						<span className="bg-hazard inline-block leading-[0.95] px-[0.08em]">Future</span>{' '}
						of{' '}
						<span className="font-serif italic font-normal normal-case inline-block leading-[0.95]">Digital</span>{' '}
						Media.
					</h1>

					<p className="font-serif text-[22px] leading-[1.45] text-ink-2 max-w-[760px] mt-8 motion-safe:animate-rise motion-safe:[animation-delay:120ms]">
						Engineering manager at Nine, in publishing. Eleven years of writing software, four leading teams. Football on Saturdays, skateboard during the week, snowboard when the season turns, and the 4x4 pointed at the bush when the noise gets too loud — and a curiosity that needs more attention than it gets. This page is the small print — the notebook, the shelves, the route.
					</p>
				</div>

				<div className="flex flex-col items-center md:items-end gap-4 mt-6 md:mt-0 min-w-0 motion-safe:animate-rise motion-safe:[animation-delay:180ms]">
					<img
						src={lcMosaic}
						alt="Luiz Cavalieri mark"
						className="w-full max-w-[min(80vw,400px)] md:max-w-[400px] aspect-square shadow-[8px_8px_0_theme('colors.ink')]"
					/>
					<div className="font-mono text-[11px] uppercase leading-[1.6] text-right text-ink-2">
						<p><strong>BY</strong> LUIZ CAVALIERI</p>
						<p><strong>FILED</strong> SYDNEY</p>
						<p><strong>SET IN</strong> BRICOLAGE / FRAUNCES</p>
					</div>
				</div>
			</div>

			<div className="mt-12 border-t-2 border-ink py-6 flex flex-wrap justify-between gap-2 font-mono text-[11px] uppercase text-ink">
				<span>Achievements · Expertise · Route · Writing</span>
				<span>↓ Scroll</span>
			</div>
		</section>
	)
}

export default HeroSection
